import { aurora as aurora$1 } from '@indeed/ifl-tokens';
import { values } from './utils.js';
import 'focus-visible';

const breakpoints = values(aurora$1.breakpoints);
const colors = { ...aurora$1.colors
};
const fonts = { ...aurora$1.fonts
};
const fontSizes = { ...aurora$1.fontSizes
};
const fontWeights = { ...aurora$1.fontWeights
};
const lineHeights = { ...aurora$1.lineHeights
};
const meta = {
  name: "aurora"
};
const radii = { ...aurora$1.borderRadius
};
const shadows = { ...aurora$1.shadows
};
const space = { ...aurora$1.spacing
};
const transitions = {
  default: `${aurora$1.durations.quick} ${aurora$1.easings.easeInOut}`,
  slow: `${aurora$1.durations.normal} ${aurora$1.easings.easeInOut}`
};
const text = {
  level8: {
    fontSize: 8,
    lineHeight: "tight"
  },
  level7: {
    fontSize: 7,
    lineHeight: "tight"
  },
  level6: {
    fontSize: 6,
    lineHeight: "tight"
  },
  level5: {
    fontSize: 5,
    lineHeight: "tight"
  },
  level4: {
    fontSize: 4,
    lineHeight: "normal"
  },
  level3: {
    fontSize: 3,
    lineHeight: "normal"
  },
  level2: {
    fontSize: 2,
    lineHeight: "normal"
  },
  level1: {
    fontSize: 1,
    lineHeight: "normal"
  }
};
const heading = {
  fontFamily: "default",
  fontWeight: "bold",
  color: "foreground.strong",
  m: 0
};
const styles = {
  root: {
    color: "foreground",
    fontFamily: "default",
    fontSize: 3,
    fontWeight: "normal",
    lineHeight: "normal",
    m: 0
  },
  a: {
    color: "foreground.action.primary",
    fontFamily: "default",
    textDecoration: "underline",
    transition: theme => `color ${theme.transitions.default}, box-shadow ${theme.transitions.default}`,
    ":hover": {
      color: "foreground.action.primary.hover"
    },
    ":active": {
      color: "foreground.action.primary.active"
    },
    ":focus": {
      outline: "none",
      boxShadow: "focus"
    },
    ":focus:not([data-focus-visible-added])": {
      outline: "none",
      boxShadow: "none"
    }
  },
  h1: { ...heading,
    variant: "text.level7",
    marginBlockEnd: 3
  },
  h2: { ...heading,
    variant: "text.level5",
    marginBlockEnd: 2
  },
  h3: { ...heading,
    variant: "text.level4",
    marginBlockEnd: 2
  },
  h4: { ...heading,
    variant: "text.level3",
    marginBlockEnd: 2
  },
  h5: { ...heading,
    variant: "text.level2",
    marginBlockEnd: 1
  },
  h6: { ...heading,
    variant: "text.level1",
    marginBlockEnd: 1
  },
  p: {
    variant: "text.level3",
    color: "foreground",
    m: 0,
    marginBlockEnd: 3
  },
  hr: {
    bg: "border.weak",
    border: 0,
    blockSize: "1px",
    marginBlockStart: 2,
    marginBlockEnd: 2
  },
  strong: {
    fontWeight: "bold"
  },
  b: {
    fontWeight: "bold"
  }
};
const aurora = {
  _themeName: "indeed",
  breakpoints,
  colors,
  direction: "ltr",
  fontSizes,
  fontWeights,
  fonts,
  lineHeights,
  meta,
  radii,
  shadows,
  space,
  styles,
  text,
  transitions
};

export { aurora };
